import { Grid, Typography } from '@mui/material'
import React from 'react'
import globalStyles from "../../assets/styles/global.module.scss";
import style from "../../assets/styles/componentStyles/campaignContactStyles/campaignContactStyle.module.scss";
import IconsColor from './iconsColor';
import GlobalButton from './globalButton/button';

interface OtpReportIssuePopupProps {
    handleReportIssue: () => Promise<void>,
}

const OtpReportIssuePopup: React.FC<OtpReportIssuePopupProps> = (props) => {
    
    const { handleReportIssue } = props;
    
    return (
        <>
            <Grid container>
                <Grid item xs={12}>
                    <Grid container className={style.popupBodyGridContainer} gap={3} mt={2} mb={1}>
                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Grid container gap={1} alignItems={"center"}>
                                <Grid item className={globalStyles.displayFlexStyle}>
                                    <IconsColor iconName="reportIssueIcon" width="36" height="36" fillColor="#EDB500" />
                                </Grid>
                                <Grid item>
                                    <Typography className={globalStyles.otpReportIssuePopupTitle}>
                                        Having trouble receiving the code?
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid item xs={12} className={`${globalStyles.fullwidth} ${globalStyles.clickOtpReportIssueGrid}`}>
                            <Typography className={globalStyles.clickOtpReportIssueText}>
                                Click the <span className={globalStyles.primaryFontWeight}>Report</span> Issue button to notify us.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Typography className={globalStyles.clickOtpReportIssueText}>
                                In the meantime, try checking your <span className={globalStyles.primaryFontWeight}>spam folder</span>, and if you still don't receive it, our team will reach out to you within <span className={globalStyles.primaryFontWeight}>24 hours</span> via email.
                            </Typography>
                        </Grid>

                        <Grid item xs={12} className={globalStyles.fullwidth}>
                            <Grid container alignItems={"center"} justifyContent={"center"}>
                                <GlobalButton
                                    className='primaryButtonStyle'
                                    buttonText="Report Issue"
                                    sx={{ width: "150px" }}
                                    onClick={() => handleReportIssue()}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default OtpReportIssuePopup
